import { Messages } from '../../codegen/Localize';
import { CommonErrorCode, ViewErrorCode } from '../helpers/ErrorCodes';
import { L10n } from '../L10n/L10n';
import { IViewInfo } from '../models/IViewInfo';
import { IErrorItem } from '../models/MultipleItemResult';
import { Module } from '../Module';
import { IErrorDetail } from './ContentActionNotification';

export class ViewErrors {

  constructor() {}

  public errorDetailsFor(viewErrorItem: IErrorItem<IViewInfo>): IErrorDetail {
    return {
      itemName: viewErrorItem.item.name,
      itemUrl: null,
      errorMessage: this.errorMessageFor(viewErrorItem)
    };
  }

  public errorMessageFor(errorItem: IErrorItem<IViewInfo>) {
    const view = errorItem.item;
    switch (errorItem.error.code) {
      case CommonErrorCode.ViewNotFound:
        return Messages.errorViewNotFound({ VIEW_NAME: L10n.elideIfLong(view.name) });
      case CommonErrorCode.CallingUserInsufficientPermissions:
        return Messages.errorViewInsufficientPermissions();
      case ViewErrorCode.ViewNameAlreadyExists:
        return Messages.errorViewNameAlreadyExists();

      default:
        return Messages.errorUnknown();
    }
  }

}

Module.instance().service('ViewErrors', ViewErrors);
